<template>
    <div class="tabs-groups panel panel-default">
        <div class="list-groups" data-infinite-scroll>
            <panel-search @search="search" placeholder="Введите наименование для поиска"
                          class="panel-search-light"></panel-search>

            <table class="table table-striped">
                <thead>
                <tr>
                    <th>Группа</th>
                    <th>Привязано салонов</th>
                    <th>ФИО создателя</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="group in groups">
                    <td>
                        <a :href="`/groups/${group.id}`">{{ group.name }}</a>
                    </td>
                    <td>{{ group.salons_count }}</td>
                    <td>{{ group.supervisor ? group.supervisor.full_name : '' }}</td>
                </tr>
                </tbody>
            </table>

            <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import 'waypoints/lib/jquery.waypoints.js'

    export default {
        data(){
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        asyncComputed: {
            groups() {
                return axios
                    .get('/api/groups', {
                        params: {
                            q: this.q,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.groups = this.groups.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        mounted() {
            // Infinite scroll
            var infContainer = $('[data-infinite-scroll]')
            if (!infContainer.length) return
            var self = this

            infContainer.waypoint({
                handler: function (direction) {
                    if (direction == 'down' && self.next_page_url) {
                        if (this.triggerPoint >= 0) {
                            self.loadNextPage()
                        }
                    }
                },
                offset: 'bottom-in-view'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// ListGroups.vue?319e33e9